import { useState } from "react";
import styles from "./styles.module.scss";
import { GridIcon, ListIcon } from "../../../assets/svgIcons";
import primaryComponents from "../../../components/primaryComponents";
import { useGetPricingTypes } from "../../../hooks/api/queries";
import secondaryComponents from "../../../components/secondaryComponents";
import { useSellModeFilters } from "../../../hooks/useSellModeFilters";
import {
  MobileMenu,
  SellModeProducts,
} from "../../../components/secondaryComponents/SellModeItemsV2";
import { Outlet, useOutletContext } from "react-router-dom";

export const PointOfSaleProducts = () => {
  const [defaultView, setDefaultView] = useState("grid");
  const { pricingType, setPricingType } = useOutletContext();
  const { data: pricingTypes, isLoading: isLoadingPricingTypes } =
    useGetPricingTypes();
  const { search, filterByInventoryType } = useSellModeFilters();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Sell Mode"
      description="View your store products, services and sell to customers"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <section className={styles.pointOfSaleProducts}>
          <div className={styles.pointOfSaleProducts__header}>
            <div className={styles.pointOfSaleProducts__header__left}>
              <button
                className={`${styles.button} ${defaultView === "grid" ? styles.active : ""}`}
                onClick={() => setDefaultView("grid")}
              >
                <GridIcon
                  color={defaultView === "grid" ? "#7647EE" : undefined}
                />
                <span>Grid View</span>
              </button>
              <button
                className={`${styles.button} ${defaultView === "list" ? styles.active : ""}`}
                onClick={() => setDefaultView("list")}
              >
                <ListIcon
                  color={defaultView === "list" ? "#7647EE" : undefined}
                />
                <span>List View</span>
              </button>
            </div>

            <div className={styles.pointOfSaleProducts__header__right}>
              <div style={{ width: "150px" }}>
                <primaryComponents.SelectField
                  options={["All", "Products", "Services"]}
                  value={
                    search.get("type") === "goods"
                      ? "Products"
                      : search.get("type") === "services"
                        ? "Services"
                        : "All"
                  }
                  onChange={(value) => {
                    filterByInventoryType(value);
                  }}
                  floatError={false}
                />
              </div>
              <div style={{ width: "150px" }}>
                {!isLoadingPricingTypes ? (
                  <primaryComponents.SelectField
                    options={pricingTypes}
                    nameKey="label"
                    idKey="id"
                    isSearchable={false}
                    value={
                      pricingTypes?.find(
                        (pricingItem) => pricingItem?.id === pricingType,
                      )?.label
                    }
                    onChange={(val) => setPricingType(val)}
                    floatError={false}
                  />
                ) : null}
              </div>
            </div>
          </div>

          <MobileMenu
            defaultView={defaultView}
            setDefaultView={setDefaultView}
            pricingType={pricingType}
            setPricingType={setPricingType}
          />

          <SellModeProducts view={defaultView} pricingType={pricingType} />
        </section>
        <Outlet />
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
